var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditIconsvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.64704 4.53125H2.76469C2.29667 4.53125 1.84781 4.71717 1.51687 5.04812C1.18592 5.37906 1 5.82792 1 6.29594V14.2371C1 14.7051 1.18592 15.154 1.51687 15.4849C1.84781 15.8158 2.29667 16.0018 2.76469 16.0018H10.7058C11.1738 16.0018 11.6227 15.8158 11.9536 15.4849C12.2846 15.154 12.4705 14.7051 12.4705 14.2371V13.3547",
    stroke: "#969696",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5885 2.76479L14.2356 5.41183M15.4576 4.16331C15.8051 3.8158 16.0004 3.34448 16.0004 2.85302C16.0004 2.36157 15.8051 1.89025 15.4576 1.54274C15.1101 1.19523 14.6388 1 14.1473 1C13.6559 1 13.1846 1.19523 12.8371 1.54274L5.41211 8.94122V11.5883H8.05915L15.4576 4.16331Z",
    stroke: "#969696",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIconsvg);
export default __webpack_public_path__ + "static/media/editIconsvg.fc0a678d7afd5aa8c036abcdf618afee.svg";
export { ForwardRef as ReactComponent };